/**
 * Order Form Handler
 */
class OrderForm {

    constructor(form, settings) {
        this.form = form;
        this.submitButton = form.querySelector('.js-order-form-submit');
        this.messageText = form.querySelector('.js-order-form-result');
        this.spinner = form.querySelector('.js-order-form-spinner');
        this.phone = form.querySelector('.js-order-form__phone');
        this.settings = settings;
        this.formActions();
    }

    formData() {
        let data = [];
        this.form.querySelectorAll('input, select, textarea').forEach((element) => {
            let value = element.value;
            if (element.type == 'checkbox' && element.checked != true) {
                value = 0;
            }
            if (element.type != 'radio' || element.checked == true) {
                data[element.getAttribute('name')] = value;
            }
        });

        return data;
    }

    validateForm(mark = false) {
        let result = true;
        let errorElement = false;
        this.form.querySelectorAll('input:required, select:required, textarea:required').forEach((element) => {
            let validation = this.validate(element,mark);
            if (!validation) {
                result = false;
                if (!errorElement) {
                    errorElement = element;
                }
            }
        });

        if (mark && !result && errorElement) {
            errorElement.scrollIntoView({ block: 'center' });
        }

        return result;
    }

    validate(element,mark) {
        let result = true;
        if (!this.validateInputLength(element)) {
            result = false;
        } else {
            if (element.getAttribute('type') == 'radio') {
                result = this.validateRadio(element);
            } else if (element.getAttribute('type') == 'email') {
                result = this.validateEmail(element);
            } else if (element.getAttribute('type') == 'tel') {
                result = this.validatePhone(element);
            }
        }

        if (mark) {
            this.toggleErrorNotice(result, element.name);
        }

        return result;
    }

    validateRadio(input) {
        let name = input.name;
        let result = true;
        if ( input.required && ! document.querySelector('input[name="'+name+'"]:checked') ) {
            result = false;
        }

        return result;
    }

    validateInputLength(input) {
        let result = true;
        if ((!input.value || (input.type == 'checkbox' && input.checked != true)) && !input.hasAttribute('disabled')) {
            result = false;
        }

        return result;
    }

    validateEmail(input) {
        let inputValue = input.value;
        let result = true;
        let pattern = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (!pattern.test(inputValue)) {
            result = false;
        }

        return result;
    }

    validatePhone(input) {
        let phone = input.value;
        let result = true;
        if ( phone.match(/\d/g) ) {
            result = phone.match(/\d/g).length === 11;
        } else {
            result = false;
        }

        return result;
    }

    toggleErrorNotice(result, name) {
        let errorField = this.form.querySelector('[data-for="' + name + '"]');
        if (errorField) {
            if (!result) {
                errorField.classList.add('noright');
                result = false;
            } else {
                errorField.classList.remove('noright');
            }
        }
    }

    checkFormIsReady() {
        if ( this.validateForm() ) {
            this.submitButton.classList.remove('disabled');
        } else {
            this.submitButton.classList.add('disabled');
        }
    }

    formActions() {
        this.submitButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.sendRequest();
        });

        this.phone.addEventListener('focus', (e) => {
            let value = e.target.value;
            if ( ! e.target.value ) {
                e.target.value = '+7';
            }
        });

        this.addListeners();
    }

    sendRequest() {
        if (!this.validateForm(true)) {
            return;
        } else {
            this.spinner.style.display = 'block';
            this.submitButton.disabled = true;
            this.submitButton.classList.add('disabled');
            this.submitButton.querySelector('span').innerText = 'Отправка...';
            let data = this.formData();
            data.source = this.settings.source;
            let payment = data.payment;
            let total = parseInt( data.qti ) * parseInt( data.price );

            let encodedData = this.encodeParams(data);

            fetch(this.settings.sendRestUrl, {
                method: 'POST', headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
                }, body: encodedData
            })
                .then(res => res.json())
                .then(response => {
                    try {
                        if ( response?.data?.fields ) {
                            response.data.fields.forEach((el) => {
                                this.form.querySelector('[data-for="' + el.name + '"]').textContent = el.message;
                            })
                        }

                        if (!response?.data?.fields ) {
                            this.form.classList.add('done');
                            this.form.scrollIntoView({ block: 'center' });
                            if (response.status == 200) {
                                if ( payment == 'invoice' ) {
                                    let number = response.orderId;
                                    this.settings.invoiceAction( total, number );
                                } else {
                                    this.settings.resultAction();
                                }

                                    //this.messageText.innerHTML = this.settings.successMessage;
                            } else if ( response.status == 302 && response.url ) {
                                window.location.href = response.url;
                            } else {
                                //this.messageText.innerHTML = this.settings.errorMessage;
                            }
                        }
                    } catch (e) {
                        //this.messageText.innerHTML = this.settings.errorMessage;
                    }
                })
                .catch(error => {
                    //this.messageText.innerHTML = this.settings.errorMessage;
                })
                .then(() => {
                    this.submitButton.disabled = false;
                    this.spinner.style.display = 'none';
                });
        }
    }

    /**
     * Makes a string of parameters to send in request to a server.
     * @param {Object} params
     * @returns {string}
     */
    encodeParams( params ) {

        return Object.entries( params ).map( param => param.map( encodeURIComponent ).join( "=" )).join( "&" );
    }

    addListeners() {
        this.form.querySelectorAll('.js-order-form__input').forEach(element => {
            element.addEventListener('change', (event) => {
                let result = this.validate(event.target);
                this.toggleErrorNotice(result, event.target.name);
                this.checkFormIsReady();
            });

        });
    }
}

export default OrderForm;
